import { render } from "./PaperAirplane.vue?vue&type=template&id=3fbcfa68"
import script from "./PaperAirplane.vue?vue&type=script&lang=js"
export * from "./PaperAirplane.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "3fbcfa68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3fbcfa68', script)) {
    api.reload('3fbcfa68', script)
  }
  
  module.hot.accept("./PaperAirplane.vue?vue&type=template&id=3fbcfa68", () => {
    api.rerender('3fbcfa68', render)
  })

}

script.__file = "src/icons/components/filled/PaperAirplane.vue"

export default script